import React, { useContext } from 'react';
import { Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import OperationContext from '../../context';
import { PageHeader, Section, LinkButton } from '../../../../../shared/components';
import EsrsContext from './context';
import NotificationContext from '../../../../Notifications/NotificationContext';
import FlowMain from '../FlowMain';
import FlowStart from '../FlowStart';
import operEsrsService from '../../../../../services/operEsrsService';
import useQuery from '../../../../../shared/hooks/useQuery';
import FlowTitleWarning from '../FlowTitleWarning';
import Context from '../../../../App/MainProvider/context';
import Role from '../../../../../types/role';
import FlowParentTitleWarning from '../FlowParentTitleWarning';

const Esrs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { operation } = useContext(OperationContext);
  const { data, loader, reload } = useContext(EsrsContext);
  const { reload: reloadNotifications } = useContext(NotificationContext);
  const { user, inSuperUserMode } = useContext(Context);

  const queryParams = useQuery();
  const from = queryParams.get('from') || undefined;

  const reloadWithNotifications = () => {
    reload();
    reloadNotifications();
  };

  const getContent = () => {
    if (!data) {
      return null;
    }
    return data.content ? (
      <FlowMain
        data={data}
        reload={reloadWithNotifications}
        operFlowService={operEsrsService}
        flowType="ESRS"
      />
    ) : (
      <FlowStart
        hasToolkitEsrr={data.hasToolkitEsrr}
        hasIndicators={data.hasIndicators}
        loader={loader}
        reload={reloadWithNotifications}
        operFlowService={operEsrsService}
        flowType="ESRS"
        milestoneCreateConditionDate={data.milestoneCreateConditionDate}
      />
    );
  };

  const GoToComments = () => {
    navigate(`${location.pathname}/comments`);
  };

  return (
    <Container className="dashboard">
      <PageHeader title={<>{t('titleEsrs', { number: operation.number })}</>} backUrl={from} />
      <Row>
        <Section
          title={data && data.content ? t('titleSectionEsrs') : ''}
          title2={
            data &&
            data.ownerOperation &&
            data.relatedOperations.length > 0 &&
            (data.ownerOperation.number !== operation.number ? (
              <FlowTitleWarning operationNumber={data.ownerOperation.number} />
            ) : (
              <FlowParentTitleWarning operations={data.relatedOperations} />
            ))
          }
          titleButton={
            data &&
            (data.flowSubtype !== 'B' || inSuperUserMode() || user.roleCode !== Role.HSO) && (
              <>
                <LinkButton onClick={GoToComments} icon="comment" text={t('comments')} />
                <span className="comment-counter">({data.commentCount})</span>
              </>
            )
          }
        >
          {getContent()}
        </Section>
      </Row>
    </Container>
  );
};

export default Esrs;
